import { toast } from "sonner";

/**
 * Copy the lead email and open the OS mail client via mailto.
 * Mailto must run synchronously in the click gesture — awaiting clipboard
 * first often makes Windows show a browser picker instead of the composer.
 */
export function composeLeadEmail(email: string): void {
  const address = email.trim();
  if (!address) return;

  const anchor = document.createElement("a");
  anchor.href = `mailto:${address}`;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  void navigator.clipboard.writeText(address).then(
    () => toast.success("Email copied"),
    () => undefined,
  );
}
